module.exports = __webpack_public_path__ + "img/case-study-ledger.1d8df78f.png";